// EditAccount.jsx
// Restyled to match KinetiQ design system.
// Uses Navbar (activePage="app") + Sidebar for the app shell.
// Layout: centred single-column card — same card shell as Login/Register
//         but without the two-panel hero split (inner app page pattern).

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { toast } from 'react-toastify';
import '../styles/EditAccount.css';

const EditAccount = () => {
  const [form, setForm] = useState({ first_name: '', last_name: '', organization: '' });

  useEffect(() => {
    // Show cached name instantly, then load the saved profile
    // (including organization) from the server.
    const nameParts = localStorage.getItem('full_name')?.split(' ') || [];
    setForm((f) => ({
      ...f,
      first_name: nameParts[0] || '',
      last_name:  nameParts[1] || '',
    }));

    const token = localStorage.getItem('token');
    axios
      .get('https://www.kinetiqmodel.com/api/account', { headers: { Authorization: token } })
      .then((res) =>
        setForm({
          first_name:   res.data.first_name   || '',
          last_name:    res.data.last_name    || '',
          organization: res.data.organization || '',
        })
      )
      .catch(() => { /* keep the cached values */ });
  }, []);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    try {
      const response = await axios.put(
        'https://www.kinetiqmodel.com/api/account/edit',
        form,
        { headers: { Authorization: token } }
      );
      localStorage.setItem('full_name', response.data.full_name);
      toast.success('Account updated successfully');
    } catch (err) {
      toast.error('Update failed. Please try again.');
    }
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', width: '100%' }}>

      <Sidebar />

      <div style={{
        marginLeft:    '220px',
        width:         'calc(100% - 220px)',
        display:       'flex',
        flexDirection: 'column',
        height:        '100vh',
        overflow:      'hidden',
      }}>

        <Navbar activePage="app" />

        <div style={{
          flex:      1,
          marginTop: '68px',
          overflowY: 'auto',
          overflowX: 'hidden',
          minHeight: 0,
        }}>
      <div className="account-page">

        {/* ── Page header ── */}
        <div className="account-page-header">
          <span className="account-page-label">My Account</span>
          <h1>Edit Profile</h1>
          <p>Update your display name and organization on the KinetiQ platform.</p>
        </div>

        {/* ── Card ── */}
        <div className="account-card">

          <div className="account-card-section-title">
            <span className="section-icon">👤</span>
            Personal Information
          </div>

          <form className="account-form" onSubmit={handleSubmit}>

            {/* Name row — side by side */}
            <div className="account-name-row">
              <div className="account-form-group">
                <label htmlFor="ea-first">First name</label>
                <input
                  id="ea-first"
                  type="text"
                  name="first_name"
                  value={form.first_name}
                  onChange={handleChange}
                  placeholder="First name"
                  required
                  autoComplete="given-name"
                />
              </div>
              <div className="account-form-group">
                <label htmlFor="ea-last">Last name</label>
                <input
                  id="ea-last"
                  type="text"
                  name="last_name"
                  value={form.last_name}
                  onChange={handleChange}
                  placeholder="Last name"
                  required
                  autoComplete="family-name"
                />
              </div>
            </div>

            {/* Organization — optional */}
            <div className="account-form-group">
              <label htmlFor="ea-org">
                Organization name <span className="account-optional">(optional)</span>
              </label>
              <input
                id="ea-org"
                type="text"
                name="organization"
                value={form.organization}
                onChange={handleChange}
                placeholder="University, company or lab"
                maxLength={255}
                autoComplete="organization"
              />
            </div>

            {/* Info note */}
            <p className="account-field-note">
              Your name is displayed in the platform header and on shared result links.
            </p>

            {/* Actions */}
            <div className="account-form-actions">
              <button type="submit" className="account-btn-primary">
                Save Changes →
              </button>
            </div>

          </form>
        </div>

      </div>

        </div>   {/* end scrollable content */}
      </div>     {/* end rightCol */}
    </div>       
  );
};

export default EditAccount;